import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "invitation",
    "results"
  ]

  static values = {
    closed: Boolean,
    voters: Array
  }

  connect() {
    const currentUser = Number(document.body.dataset.currentUserId)

    if((currentUser == 0) || this.votersValue.includes(currentUser) || this.closedValue) {
      this.showResult()
    } else {
      this.showInvitation()
    }
  }

  showInvitation() {
    this.invitationTarget.classList.remove("hidden")
  }

  showResult() {
    this.resultsTarget.classList.remove("hidden")
  }
}
